import { RouteConfig } from '../types/route'

/**
 * 判断是否为真实的路由节点或布局节点，而不是操作权限配置节点
 *
 * @param config 路由项
 * @returns 是路由节点返回 true，否则返回 false
 */
export const isRoute = (
  config: Pick<RouteConfig, 'path' | 'element' | 'Component'>
) => {
  return config.path || config.element || config.Component
}
